import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import type { Observable } from 'rxjs';

import { OptionalAsyncPipe } from '../../../pipes/OptionalAsync.pipe';

@Component({
  selector: 'evc-copyright',
  imports: [OptionalAsyncPipe],
  templateUrl: './copyright.component.html',
  styleUrls: ['./copyright.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CopyrightComponent {
  public readonly copyRightText = input<Observable<string> | string>('© Evident Scientific');

  public year: string = new Date().getFullYear().toString();
}
